import { Button, styled } from "@mui/material";
import AppModal from "components/AppModal";
import { H2 } from "components/Typography";
import { t } from "i18next";
import { FC } from "react";
import { SectionEntity } from "api/generated";
import FlexBox from "components/flexbox/FlexBox";
import { ticketApi } from "api";

interface ModalProps {
    open: boolean;
    onClose: () => void;
    fetchData: () => void;
    section?: SectionEntity;
    date?: Date
}

const StyledAppModal = styled(AppModal)(({ theme }) => ({
    width: 450,

    [theme.breakpoints.down(325)]: { maxWidth: '100%' },
}));

const ConfirmTicketModal: FC<ModalProps> = (
    {
        open,
        onClose,
        section,
        date,
        fetchData
    }
) => {


    const onConfirm = async () => {
        if (!date || !section)
            return;
        await ticketApi.confirmDailyTickets(+date, section.id);
        fetchData();
        onClose();
    }

    return (
        <StyledAppModal open={open} handleClose={() => { onClose() }} >
            <H2>{t('confirmMoney')}</H2>

            <FlexBox mt={3}>
            { 
                t('ticketExtra.confirmDescription',
                    {
                        date: date?.toLocaleDateString('it-IT'),
                        section: section?.name 
                    }
                )
            }
            </FlexBox>

            <FlexBox justifyContent='flex-end' gap={2} marginTop={4}>
                <Button
                    fullWidth
                    variant="contained"
                    color="error"
                    onClick={() => { onClose() }}>
                    {t('cancel')}
                </Button>
                <Button
                    fullWidth
                    variant="contained"
                    onClick={() => { onConfirm() }}>
                    {t('confirm')}
                </Button>
            </FlexBox>

        </StyledAppModal>
    )
}

export default ConfirmTicketModal;